import { useTranslation } from 'react-i18next'

// Two buttons (RO / EN). Clicking one calls i18n.changeLanguage,
// which the detector module persists to localStorage automatically.
//
// (When the user is logged in, the AuthContext also keeps their
// users.language column in sync — handled on the backend; will be
// added when we wire up a /api/me PATCH endpoint.)

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const current = (i18n.resolvedLanguage || i18n.language || 'ro').slice(0, 2)

  const set = (lng) => () => i18n.changeLanguage(lng)

  return (
    <div className="lang-switch" role="group" aria-label={t('common.language')}>
      <button
        type="button"
        onClick={set('ro')}
        className={current === 'ro' ? 'active' : ''}
        aria-pressed={current === 'ro'}
      >RO</button>
      <button
        type="button"
        onClick={set('en')}
        className={current === 'en' ? 'active' : ''}
        aria-pressed={current === 'en'}
      >EN</button>
    </div>
  )
}
